// Indicative APR band shown to buyers before staff return real lender terms.
export const APR_BAND = { low: 6.49, high: 8.99 };

export function monthlyPayment(principal, aprPercent, termMonths) {
  const p = Number(principal) || 0;
  const term = Number(termMonths) || 0;
  if (p <= 0 || term <= 0) return 0;
  const r = (Number(aprPercent) || 0) / 100 / 12;
  if (r === 0) return p / term;
  return (p * r) / (1 - Math.pow(1 + r, -term));
}
